module.exports = __webpack_public_path__ + "static/img/logo.7218440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 82
// module chunks = 0